// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"360":"8803f692","521":"8803f692","819":"8803f692"}[chunkId] + ".chunk.css";
};